import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnProcessState } from './bpmn-process-state.selector';

const getBpmnProcessXml = (state: State): any => state.bpmnXml;

export const selectBpmnProcessXml: MemoizedSelector<
  object,
  string
  > = createSelector(selectBpmnProcessState, getBpmnProcessXml);
